import { useDocsBeServiceInspectQuery as useDocsServiceInspectQuery } from "@newHooks/query/serviceInspect/docsServiceInspect.query";
import { VersionComparator } from "@schemas/version/version";

const isFrontendOutdated = (backendVersion: string, frontendVersion: string): boolean => {
  return VersionComparator.isGreaterThan(backendVersion, frontendVersion);
};

export function useVersionCheck() {
  const { data: inspectData } = useDocsServiceInspectQuery();

  return { isOutdated: !!inspectData?.version && isFrontendOutdated(inspectData.version, process.env.REACT_APP_VERSION || "0.0.0") };
}
